module.exports = __webpack_public_path__ + "img/member-verify-bg-1.570cc7b7.png";